<template>
  <modal
    name="edit-permit-ivitation"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="550"
    height="auto"
    @before-open="getData"
    @before-close="resetData"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Edit Permit Invitation</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group">
            <label class="txt--ss txt--off-white mb-2"> Group name </label>
            <input
              type="text"
              class="textInputField"
              placeholder="Enter a group name"
              v-model.trim="invitation_name"
            />
          </div>
          <div>
            <label class="txt--ss txt--off-white mb-2">
              Permit (required)
            </label>
            <div v-if="selected_permit_list.length>0">
              <div class="mb-2 input-wrapper-remove" v-for="(permit,index) in selected_permit_list" :key="index">
                <input
                  type="text"
                  class="textInputField"
                  v-model="permit.permit_name"
                  readonly
                />
                <p class="remove-btn" @click="removePermit(index)">REMOVE</p>
              </div>
            </div>
          </div>
          <p
            class="txt--xs cursor-pointer opacity--25 mb-2"
            @click="addMorePermit = true"
          >
            + Add permit
          </p>
          <div class="form-group" v-if="addMorePermit">
            <multiselect
              class="multi-select-input"
              v-model="selected_permit_list"
              :options="permit_options"
              :close-on-select="false"
              :multiple="true"
              group-values="permit_details"
              group-label="property_name"
              :group-select="true"
              placeholder="Select Permits"
              track-by="permit_id"
              label="permit_name"
            >
              <span slot="noResult" class="txt--ss">Please add permits to continue!</span>
              <template slot="tag" slot-scope="{ option, remove }"
                ><span class="multiselect__tag">
                  <span>{{ option.property_name + " - " + option.permit_name }}</span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    class="multiselect__tag-icon"
                    @click="remove(option)"
                  ></i> </span
              ></template>
            </multiselect>
          </div>
          <div class="form-group">
            <label class="txt--ss txt--off-white mb-2">
              Number of property choices (optional)
            </label>
            <input
              type="number"
              class="textInputField"
              placeholder="Enter # of property choices an invitee can select"
              v-model.number="available_selections"
              @keypress="checkNumber"
            />
          </div>
          <div class="form-group">
            <div class="form-row">
              <div class="col-sm-6">
                <label class="txt--ss txt--off-white mb-2">
                  Invitation expiry date (optional)
                </label>
                <datetime
                  title="Expiration Date"
                  input-id="start_date"
                  class="dateTime__picker"
                  format="MM-dd-yyyy HH:mm:ss"
                  :input-class="['textInputField']"
                  value-zone="local"
                  type="datetime"
                  :clear-button="true"
                  placeholder="MM/DD/YYYY HH:mm:ss"
                  :min-datetime="start_date"
                  v-model="expiration_date"
                ></datetime>
              </div>
              <div class="col-sm-3 d-flex justify-content-center align-items-center mt-4 pt-1" v-if="expiration_date">
                <a href="javascript:void(0);" class="txt--ss txt--off-white mb-2" @click="expiration_date=null">Clear</a>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center flex-wrap pt-4">
            <ButtonWithSpinner
              class="button button--primary button--sm mr-3 mb-2"
              :disabled="button.disabled"
              :loading="button.loading"
              :success="button.success"
              @click="updateInvitation"
            >
              Send</ButtonWithSpinner
            >
            <button
              type="button"
              class="button button--outline button--sm mb-2"
              @click="closeModal()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
import ButtonWithSpinner from "@/components/Button";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  name: "Edit-Permit-Invitations",
  components: {
    datetime: Datetime,
    ButtonWithSpinner,
  },
  data() {
    return {
      invitation_id: '',
      invitation_name: '',
      available_selections: 1,
      start_date: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
      expiration_date: null,
      selected_property_list: [],
      selected_permit_list: [],
      addMorePermit: false,
      permit_options: [],
      button: {
        loading: false,
        success: false,
        disabled: false,
      },
    };
  },
  computed: {},
  created() {
    this.getPermitList();
  },
  methods: {
    getData(e) {
      this.invitation_name = e.params.invitation.invitation_name;
      this.invitation_id = e.params.invitation.id;
      this.available_selections = e.params.invitation.available_selections;
      this.start_date = this.$moment(e.params.invitation.start_date).format("YYYY-MM-DDTHH:mm:ss.sssZ");
      let current_date = this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ");
      let diff = this.$moment(this.start_date).diff(current_date);
      if(diff < 0) {
        this.start_date = current_date;
      }
      this.expiration_date = e.params.invitation.expiration_date!='' ? this.$moment(e.params.invitation.expiration_date).format("YYYY-MM-DDTHH:mm:ss.sssZ") : null;

      e.params.invitation.properties.map(val=> {
        this.selected_property_list.push(val.property_id);
      });

      let selected_permit_ids = e.params.invitation.permit_list;

      if(selected_permit_ids.length>0) {
        this.permit_options.map((option)=> {
          if(this.selected_property_list.indexOf(option.property_id)!==-1) {

            let permit_list = option.permit_details;

            permit_list.map((permit) => {
              if(selected_permit_ids.indexOf(permit.permit_id) !==-1) {
                this.selected_permit_list.push(permit);
              }
            });
          }
        });
      }
      else {
        this.permit_options.map((option) => {
          if(this.selected_property_list.indexOf(option.property_id)!==-1) {
            let permit_list = option.permit_details;
            permit_list.map((permit)=> {
              this.selected_permit_list.push(permit);
            });
          }
        });
      }

      if(this.invitation_id=='') {
        this.closeModal();
      }
    },
    getPermitList() {
      this.axios.post(window.hostname + "/api/auth/permit/list",{
        commercial: 1,
        all: 1,
      })
      .then(res=> {
        if(res.data.status) {
          let permits = res.data.data.permit_list;
          if(permits.length>0) {
            permits.map((val) => {
              let foundIndex = -1;
              this.permit_options.map((value,index)=> {
                if(value.property_id == val.property_id) {
                  foundIndex = index;
                  this.permit_options[index].permit_details.push({
                    permit_name: val.permit_name,
                    permit_id: val.permit_id,
                    property_name: val.property_name,
                    property_id: val.property_id
                  });
                }
              });

              if(foundIndex==-1) {
                this.permit_options.push({
                  property_id: val.property_id,
                  property_name: val.property_name,
                  permit_details: [{
                    permit_name: val.permit_name,
                    permit_id: val.permit_id,
                    property_name: val.property_name,
                    property_id: val.property_id
                  }]
                });
              }
            });
          }
        }
        else {
          this.permit_options = [];
        }
      })
      .catch(err=> {
        console.log(err);
        if (err.response) console.log(err.response.data.message);
        this.closeModal();
      })
    },
    removePermit(index) {
      this.$delete(this.selected_permit_list,index);
    },
    checkNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
      return true;
    },
    updateInvitation() {
      if(this.invitation_name == '') {
        this.$toasted.show("Please provide a group name!",{ 
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      if(this.selected_permit_list.length == 0) {
        this.$toasted.show("Please select at least one permit!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      if(this.available_selections <=0) {
        this.$toasted.show("Please provide a valid number for available selections!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      this.selected_property_list = [];
      this.selected_permit_list.map((val)=> {
        if(this.selected_property_list.indexOf(val.property_id)==-1) {
          this.selected_property_list.push(val.property_id);
        }
      });

      if(this.available_selections > this.selected_property_list.length) {
        this.$toasted.show("Number of available selections can not be more than the number of properties!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      let permit_ids = this.selected_permit_list.map((val)=> {return val.permit_id});

      this.button.disabled = true;
      this.button.loading = true;
      this.button.success = false;

      this.axios.post(window.hostname+'api/auth/invitation/update',{
        invitation_id: this.invitation_id,
        invitation_name: this.invitation_name,
        property_ids: this.selected_property_list,
        permit_list: permit_ids,
        expiration_date: this.expiration_date ? this.$moment(this.expiration_date).utc().format("YYYY-MM-DD HH:mm:ss") : null,
        available_selections: this.available_selections
      })
      .then(res=> {
        this.button.disabled = false;
        this.button.loading = false;
        if(res.data.status) {
          this.button.success = true;
          this.$toasted.show(res.data.message,{
            icon: 'check-circle',
            className: 'success-class'
          });
          this.$emit("update_invitation_list");
        }
        else {
          this.button.success = false;
          this.$toasted.show(res.data.message,{
            icon: 'times-circle',
            className: 'error-class'
          });
        }    
      })
      .catch(err=> {
        this.button.disabled = false;
        this.button.loading = false;
        this.button.success = false;
        console.log(err);
      })
    },
    closeModal() {
      this.$modal.hide("edit-permit-ivitation");
    },
    resetData() {
      this.invitation_id = '';
      this.invitation_name = '';
      this.available_selections = 1;
      this.start_date= this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ");
      this.expiration_date = null;
      this.selected_permit_list = [];
      this.selected_property_list = [];
      this.addMorePermit = false;
      this.button.disabled = false;
      this.button.success = false;
      this.button.loading = false;
    }
  },
};
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}

.monthly-filter-select {
  width: 100%;
}

/* style the background and the text color of the input ... */
.vue-tags-input {
  border-radius: 16px !important;
  background: transparent !important;
  font-size: 12px !important;
  padding: 0 0.6rem !important;
  border: 1px solid hsla(0, 0%, 100%, 0.25) !important;
  max-width: 100% !important;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  color: hsla(0, 0%, 100%, 0.5);
}
.vue-tags-input.ti-focus {
  border-color: #f5a621 !important;
}

.vue-tags-input .ti-new-tag-input {
  background: transparent !important;
  color: #b7c4c9;
}

.ti-input {
  border: 0 !important;
  padding: 4px 10px;
  transition: border-bottom 200ms ease;
}

/* we cange the border color if the user focuses the input */
.vue-tags-input.ti-focus .ti-input {
  border: 1px solid #ebde6e;
}

/* some stylings for the autocomplete layer */
.vue-tags-input .ti-autocomplete {
  background: #191919 !important;
  border: 0 !important;
  border-top: none !important;
  border-radius: 10px !important;
  width: 148px !important;
  top: 35px !important;
  padding-top: 10px !important;
}

/* the selected item in the autocomplete layer, should be highlighted */
.vue-tags-input .ti-item {
  color: #fff;
}
.vue-tags-input .ti-item.ti-selected-item {
  background-color: transparent;
}

/* style the placeholders color across all browser */
.vue-tags-input ::-webkit-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input ::-moz-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-ms-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-moz-placeholder {
  color: #a4b1b6;
}

/* default styles for all the tags */
.vue-tags-input .ti-tag {
  position: relative !important;
  background: transparent !important;
  color: #fff !important;
  align-items: center !important;
}

/* the styles if a tag is invalid */
.vue-tags-input .ti-tag.ti-invalid {
  background-color: #e88a74;
}

/* if the user input is invalid, the input color should be red */
.vue-tags-input .ti-new-tag-input.ti-invalid {
  color: #e88a74;
}

/* if a tag or the user input is a duplicate, it should be crossed out */
.vue-tags-input .ti-duplicate span,
.vue-tags-input .ti-new-tag-input.ti-duplicate {
  text-decoration: line-through;
}

/* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
.vue-tags-input .ti-tag:after {
  transition: transform 0.2s;
  position: absolute;
  content: "";
  height: 2px;
  width: 108%;
  left: -4%;
  top: calc(50% - 1px);
  background-color: #000;
  transform: scaleX(0);
}

.vue-tags-input .ti-deletion-mark:after {
  transform: scaleX(1);
}
.ti-tag .ti-actions {
  background-color: rgba(255, 255, 255, 0.2) !important;
  font-size: 8px !important;
  justify-content: center !important;
  width: 13px !important;
  height: 13px !important;
  border-radius: 100% !important;
  color: rgba(255, 255, 255, 0.25) !important;
}
.date-range-time-class-audit .date__range__input .field.is-dark .field-input {
  width: 150px;
  padding: 0 10px;
}
.date-range-time-class-audit .time-picker::after,
.date-range-time-class-audit .time-picker::before {
  border-top: 0;
  border-bottom: 0;
}

@media (max-width: 460px) {
  .date-range-time-class-audit {
    flex-direction: column;
  }
  .date-range-time-class-audit .separator {
    display: none;
  }
  .date-range-time-class-audit .date__range__input {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
</style>
